import { createFileRoute } from '@tanstack/react-router'
import { AdminPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/fr/admin/')({
  head: () => noIndexRouteHead('admin', 'fr'),
  component: AdminPage,
})
